import { useIntl } from "react-intl";

export const usePdfLabels = () => {
    const intl = useIntl();

    return {
        header: intl.formatMessage({ id: "common.app.title" }),
        questionTitle: intl.formatMessage({ id: "export.pdf.title.question" }),
        answerTitle: intl.formatMessage({ id: "export.pdf.title.answer" }),
        answerTableTitle: intl.formatMessage({ id: "export.pdf.title.answerTable" }),
        dateHeader: intl.formatMessage({ id: "export.pdf.header.date" }),
        dateFooter: intl.formatMessage({ id: "export.pdf.footer.date" }),
        subtitleFull: intl.formatMessage({ id: "export.pdf.subtitle.full" }),
        subtitleTableOnly: intl.formatMessage({ id: "export.pdf.subtitle.tableOnly" }),
    };
};
